var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortcutComponent",
      attrs: {
        btOkName: _vm.$t(
          "__.Crud.produtolote.atualizarStatus_vue_html.atualizar"
        ),
        modalClass: "ld-modal",
      },
      on: { "selection-item": _vm.onAtualizarStatus },
    },
    [
      _c("div", { attrs: { slot: "component" }, slot: "component" }, [
        _c("form", { attrs: { novalidate: "novalidate" } }, [
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "descricao" },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.produtolote.edit_vue_html.statusProdutoLote"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("combo-component", {
                      attrs: {
                        id: "statusProdutoLote",
                        name: "statusProdutoLote",
                        data: _vm.statusProdutoLoteOptions,
                        disabled: "",
                      },
                      model: {
                        value: _vm.produtoLoteModel.statusProdutoLote,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.produtoLoteModel,
                            "statusProdutoLote",
                            $$v
                          )
                        },
                        expression: "produtoLoteModel.statusProdutoLote",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("newStatusProdutoLote"),
                        expression: "errors.first('newStatusProdutoLote')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "descricao",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.produtolote.atualizarStatus_vue_html.newStatusProdutoLote"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("combo-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "newStatusProdutoLote",
                        name: "newStatusProdutoLote",
                        data: _vm.statusProdutoLoteOptions,
                      },
                      model: {
                        value: _vm.newStatusProdutoLote,
                        callback: function ($$v) {
                          _vm.newStatusProdutoLote = $$v
                        },
                        expression: "newStatusProdutoLote",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }